import { motion } from 'framer-motion';
import Button from '../base/Button';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with lazy loading */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/56a8397ba0391fd0fd0f03e2b9ff50e8.jpg"
          alt="Servicio profesional de vaciado de pisos en Granollers"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight px-2">
            Vaciado de pisos y limpieza extrema en <span className="text-primary">Granollers</span>
          </h1>
          
          <p className="text-lg sm:text-xl md:text-2xl text-white/95 mb-10 max-w-3xl mx-auto leading-relaxed px-4">
            Servicio profesional de <strong>vaciado de pisos</strong>, <strong>limpieza por síndrome de Diógenes</strong> y <strong>retirada de muebles</strong> en Granollers y todo el Vallès Oriental. Rápido, discreto y eficiente.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12 px-4">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => window.location.href = '/contacto'}
              icon={<i className="ri-send-plane-line"></i>}
            >
              Solicitar Presupuesto
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              onClick={() => window.location.href = 'tel:+34602365996'}
              icon={<i className="ri-phone-line"></i>}
              className="border-white text-white hover:bg-white hover:text-primary"
            >
              Llamar 602 36 59 96
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-white/90 px-4">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-primary text-xl sm:text-2xl w-5 sm:w-6 h-5 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
              <span className="font-medium text-sm sm:text-base">Presupuesto sin compromiso</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-time-line text-primary text-xl sm:text-2xl w-5 sm:w-6 h-5 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
              <span className="font-medium text-sm sm:text-base">Respuesta en 24 horas</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-shield-check-line text-primary text-xl sm:text-2xl w-5 sm:w-6 h-5 sm:h-6 flex items-center justify-center flex-shrink-0"></i>
              <span className="font-medium text-sm sm:text-base">100% Profesional</span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.8 }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center p-2">
          <motion.div 
            className="w-1 h-2 bg-white/70 rounded-full"
            animate={{ y: [0, 12, 0] }}
            transition={{ duration: 1.5, repeat: Infinity }}
          />
        </div>
      </motion.div>
    </section>
  );
}
